import { useEffect, useMemo, useState } from "react";

import { UserRoles } from "@intelligems/ig-types";
import { useGetOrgList } from "@src/api/organizations-list/get-organization-list";

import { useGetOrg } from "../organizations/get-organization";

import { useLoggedInUser } from "./login";

export const useIsIntelligems = () => {
  const [isIntelligems, setIsIntelligems] = useState<boolean | undefined>(
    undefined
  );
  const user = useLoggedInUser();
  const org = useGetOrg();
  const orgList = useGetOrgList();

  const userRoles: UserRoles[] | undefined = useMemo(() => {
    if (orgList.isSuccess) {
      const foundOrg = orgList.data.orgs.find((o) => o.id === org.data.org.id);
      return foundOrg ? foundOrg.roles : ["member"];
    }
  }, [orgList.isSuccess, org.data.org.id]);

  useEffect(() => {
    if (userRoles !== undefined) {
      setIsIntelligems(userRoles.some((p) => p === "intelligems"));
    }
  }, [org.data.org.id, user.isSuccess, user.data, userRoles]);

  return isIntelligems;
};
